export class TabButtonEvent {
  constructor(public action = -1, public tabIndex = -1, public value?) {
  }
}
